<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0" primary-title>
          Setar Cliente
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="cliente"
            :items="clientesAtivo"
            item-text="Fantasia"
            return-object
            menu-props="auto"
            label="Cliente"
            hide-details
            prepend-icon="group_add"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado."
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  props: ["value", "atividadeCliente", "loading"],
  data() {
    return {
      cliente: null
    };
  },
  methods: {
    ...mapMutations(["showNotification"]),
    ...mapActions(["fetchClientes"]),
    adiciona() {
      if (this.cliente) {
        if (this.atividadeCliente !== null) {
          this.atividadeCliente.IdCliente = this.cliente.IdCliente;
          this.atividadeCliente.Fantasia = this.cliente.Fantasia;
          this.$emit("setaCliente", this.atividadeCliente);
          this.cliente = null;
        } else {
          this.$emit("setaClienteSelected", this.cliente);
          this.cliente = null;
        }
      } else {
        this.showNotification({ text: "Informe o cliente", status: 'error' });
      }
    }
  },
  computed: {
    ...mapGetters(["clientesAtivo"])
  },
  async created() {
    if (!this.clientesAtivo.length) {
      await this.fetchClientes();
    }
  }
};
</script>

<style>
</style>
